import "./hb-features.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

export default (user) => html`
    <div
        id="hb-features"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        Advanced Features ℹ️
                    </h3>
                    <button
                        type="button"
                        class="${isPopup
                            ? "hidden"
                            : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="hb-features">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form
                    id="hb-features-form"
                    class="p-4 space-y-4 text-base leading-loose text-gray-900 dark:text-white">
                    <div class="grid gap-6 mb-6">
                        <div>
                            <label
                                for="hb-features-checkin"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <aside>
                                    <button type="button">
                                        Check-In Geolocation
                                        <svg
                                            class="hidden w-4 h-4 ms-2 text-gray-400 hover:text-gray-500"
                                            aria-hidden="true"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                        ℹ️
                                        <span class="sr-only"
                                            >Show information
                                        </span>
                                    </button>
                                </aside>
                                <svg
                                    id="hb-features-checkin-on"
                                    class="hidden w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="orange"
                                    viewBox="0 0 384 512">
                                    <path
                                        d="M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6c0 119.3-120.2 262.3-170.4 316.8-11.8 12.8-31.5 12.8-43.3 0-50.2-54.5-170.4-197.5-170.4-316.8zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z" />
                                </svg>
                                <svg
                                    id="hb-features-checkin-off"
                                    class="w-5 h-5"
                                    fill="gray"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 384 512">
                                    <path
                                        d="M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6c0 119.3-120.2 262.3-170.4 316.8-11.8 12.8-31.5 12.8-43.3 0-50.2-54.5-170.4-197.5-170.4-316.8zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z" />
                                </svg>
                            </label>
                            <div
                                class="w-full mb-0 inline-flex rounded-md shadow-xs"
                                role="group">
                                <button
                                    id="hb-features-checkin-enable"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Always Public
                                </button>
                                <button
                                    id="hb-features-checkin-disable"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Always Private
                                </button>
                            </div>
                        </div>
                        <div>
                            <label
                                for="hb-features-locker"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span>From Locker ℹ️</span>
                                <label
                                    for="hb-features-locker-show"
                                    class="opacity-50 inline-flex items-center cursor-pointer">
                                    <span
                                        id2="hb-features-locker-label"
                                        class="hidden mr-2 text-xs">
                                        Hide
                                    </span>
                                    <input
                                        id="hb-features-locker-show"
                                        type="checkbox"
                                        checked
                                        class="sr-only peer" />
                                    <div
                                        class="relative outline-0 w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                                </label>
                                <span class="hidden text-base ml-5">🔐</span>
                            </label>
                            <ul
                                class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <li
                                    class="${user
                                        ? "border-b"
                                        : "hidden"} w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-features-locker-public"
                                            type="radio"
                                            value="public"
                                            name="hb-features-locker"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-features-locker-public"
                                            class="w-full inline-flex items-center justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">
                                                Always Public
                                            </span>
                                            <span class="mr-4 text-xs">
                                                Primary Locker
                                            </span>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-features-locker-anonymous"
                                            type="radio"
                                            value="anonymous"
                                            name="hb-features-locker"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-features-locker-anonymous"
                                            class="w-full inline-flex items-center justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">
                                                Always Anonymous
                                            </span>
                                            <span class="mr-4 text-xs">
                                                Random Locker
                                            </span>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b-0 border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-features-locker-manual"
                                            type="radio"
                                            value="manual"
                                            name="hb-features-locker"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-features-locker-manual"
                                            class="w-full inline-flex justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">
                                                Manual Selection
                                            </span>
                                            <label
                                                for="hb-features-locker-shuffle"
                                                class="mr-4 inline-flex items-center cursor-pointer">
                                                <span
                                                    id="hb-features-locker-label"
                                                    class="mr-2 text-xs">
                                                    Shuffle
                                                </span>
                                                <input
                                                    id="hb-features-locker-shuffle"
                                                    type="checkbox"
                                                    class="sr-only peer" />
                                                <div
                                                    class="relative outline-0 w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                                            </label>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="${user ? "" : "hidden"}">
                            <label
                                for="hb-features-safe"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span>From Safe ℹ️</span>
                                <label
                                    for="hb-features-safe-show"
                                    class="opacity-50 inline-flex items-center cursor-pointer">
                                    <span
                                        id2="hb-features-safe-label"
                                        class="hidden mr-2 text-xs">
                                        Hide
                                    </span>
                                    <input
                                        id="hb-features-safe-show"
                                        type="checkbox"
                                        checked
                                        class="sr-only peer" />
                                    <div
                                        class="relative outline-0 w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                                </label>
                                <span class="hidden text-base ml-5">🔒</span>
                            </label>
                            <ul
                                class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg flex-col dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <li
                                    class="w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-features-safe-public"
                                            type="radio"
                                            value="public"
                                            checked
                                            name="hb-features-safe"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-features-safe-public"
                                            class="w-full inline-flex items-center justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">
                                                Always Public
                                            </span>
                                            <span class="mr-4 text-xs">
                                                Primary Safe
                                            </span>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-features-safe-anonymous"
                                            type="radio"
                                            value="anonymous"
                                            name="hb-features-safe"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-features-safe-anonymous"
                                            class="w-full inline-flex items-center justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">
                                                Always Anonymous
                                            </span>
                                            <span class="mr-4 text-xs">
                                                Random Safe
                                            </span>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b-0 border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-features-safe-manual"
                                            type="radio"
                                            value="manual"
                                            name="hb-features-safe"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-features-safe-manual"
                                            class="w-full inline-flex justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">
                                                Manual Selection
                                            </span>
                                            <label
                                                for="hb-features-safe-shuffle"
                                                class="mr-4 inline-flex items-center cursor-pointer">
                                                <span
                                                    id="hb-features-safe-label"
                                                    class="mr-2 text-xs">
                                                    Shuffle
                                                </span>
                                                <input
                                                    id="hb-features-safe-shuffle"
                                                    type="checkbox"
                                                    class="sr-only peer" />
                                                <div
                                                    class="relative outline-0 w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                                            </label>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="opacity-50">
                            <label
                                for="hb-features-ar"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <aside>
                                    <button type="button">
                                        Augmented Reality
                                        <svg
                                            class="hidden w-4 h-4 ms-2 text-gray-400 hover:text-gray-500"
                                            aria-hidden="true"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                        ℹ️
                                        <span class="sr-only"
                                            >Show information
                                        </span>
                                    </button>
                                </aside>
                                <svg
                                    id="hb-features-ar-on"
                                    class="hidden w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="teal"
                                    viewBox="0 0 576 512">
                                    <path
                                        d="M143.3 96c-14 0-26.5 9.2-30.6 22.6L70.4 256 224 256c17.7 0 32 14.3 32 32l64 0c0-17.7 14.3-32 32-32l153.6 0-42.3-137.4C459.2 105.2 446.8 96 432.7 96L400 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l32.7 0c42.1 0 79.4 27.5 91.8 67.8l45.4 147.5c4.1 13.2 6.1 26.9 6.1 40.7l0 96c0 53-43 96-96 96l-64 0c-53 0-96-43-96-96l0-32-64 0 0 32c0 53-43 96-96 96l-64 0c-53 0-96-43-96-96l0-96c0-13.8 2.1-27.5 6.1-40.7L51.5 99.8C63.9 59.5 101.1 32 143.3 32L176 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.7 0zM64 320l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64-128 0zm416 96c17.7 0 32-14.3 32-32l0-64-128 0 0 64c0 17.7 14.3 32 32 32l64 0z" />
                                </svg>
                                <svg
                                    id="hb-features-ar-off"
                                    class="w-5 h-5"
                                    fill="gray"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512">
                                    <path
                                        d="M143.3 96c-14 0-26.5 9.2-30.6 22.6L70.4 256 224 256c17.7 0 32 14.3 32 32l64 0c0-17.7 14.3-32 32-32l153.6 0-42.3-137.4C459.2 105.2 446.8 96 432.7 96L400 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l32.7 0c42.1 0 79.4 27.5 91.8 67.8l45.4 147.5c4.1 13.2 6.1 26.9 6.1 40.7l0 96c0 53-43 96-96 96l-64 0c-53 0-96-43-96-96l0-32-64 0 0 32c0 53-43 96-96 96l-64 0c-53 0-96-43-96-96l0-96c0-13.8 2.1-27.5 6.1-40.7L51.5 99.8C63.9 59.5 101.1 32 143.3 32L176 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.7 0zM64 320l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64-128 0zm416 96c17.7 0 32-14.3 32-32l0-64-128 0 0 64c0 17.7 14.3 32 32 32l64 0z" />
                                </svg>
                            </label>
                            <div
                                class="w-full mb-0 inline-flex rounded-md shadow-xs"
                                role="group">
                                <button
                                    id="hb-features-ar-enable"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Enable
                                </button>
                                <button
                                    id="hb-features-ar-disable"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Disable
                                </button>
                            </div>
                        </div>
                        <div class="opacity-50">
                            <label
                                for="hb-features-vr"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <aside>
                                    <button type="button">
                                        Virtual Reality
                                        <svg
                                            class="hidden w-4 h-4 ms-2 text-gray-400 hover:text-gray-500"
                                            aria-hidden="true"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                        ℹ️
                                        <span class="sr-only"
                                            >Show information
                                        </span>
                                    </button>
                                </aside>
                                <svg
                                    id="hb-features-vr-on"
                                    class="hidden w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="teal"
                                    viewBox="0 0 576 512">
                                    <path
                                        d="M512 96L64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l117.5 0c17 0 33.3-6.7 45.3-18.7l33.9-33.9c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3l33.9 33.9c12 12 28.3 18.7 45.3 18.7L512 416c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64zM80 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm352-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                </svg>
                                <svg
                                    id="hb-features-vr-off"
                                    class="w-5 h-5"
                                    fill="gray"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512">
                                    <path
                                        d="M512 96L64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l117.5 0c17 0 33.3-6.7 45.3-18.7l33.9-33.9c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3l33.9 33.9c12 12 28.3 18.7 45.3 18.7L512 416c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64zM80 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm352-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                </svg>
                            </label>
                            <div
                                class="w-full mb-0 inline-flex rounded-md shadow-xs"
                                role="group">
                                <button
                                    id="hb-features-vr-enable"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Enable
                                </button>
                                <button
                                    id="hb-features-vr-disable"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Disable
                                </button>
                            </div>
                        </div>
                    </div>
                    <p
                        id="hb-features-message"
                        class="text-base font-medium mb-0 text-gray-500 dark:text-gray-300"></p>
                </form>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="hb-features-save"
                        class="text-white w-full bg-yellow-700 hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-base px-5 py-2.5 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
